import { render, staticRenderFns } from "./EditContactDialog.vue?vue&type=template&id=0116b898&"
import script from "./EditContactDialog.vue?vue&type=script&lang=ts&"
export * from "./EditContactDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports